import gql from "graphql-tag";

export const SURVEY_RESPONSE_SUBSCRIPTION = gql`
subscription exportStatusSubscription {
  exportStatusSubscription {
    mutation
    filePath
    taskId
  }
}
`
